import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'cms-content-tabs',
  name: '内容类型Tab',
  icon: '签',
  group: 'CMS通用',
  description: '信息流页的内容类型切换标签栏。',
  defaultProps: {
    defaultTab: '',
    showIndicator: true,
    tabs: [
      { label: '全部', value: '' },
      { label: '图文', value: 'ARTICLE' },
      { label: '视频', value: 'VIDEO' },
      { label: '动态', value: 'MOMENT' }
    ]
  }
}
